<table
  mat-table
  [dataSource]="ds"
  #aSort="matSort"
  matSort
  class="mat-elevation-z0"
  matSortActive="uploaded"
  matSortDisableClear
  matSortDirection="desc"
>
  <ng-container matColumnDef="fileName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Filename</th>
    <td mat-cell *matCellDef="let element">{{ element.fileName }}</td>
  </ng-container>
  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
    <td mat-cell *matCellDef="let element">{{ element.status }}</td>
  </ng-container>
  <ng-container matColumnDef="uploaded">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Uploaded</th>
    <td mat-cell *matCellDef="let element">
      {{ element.uploaded | date: "medium":"+0200":"de" }}
    </td>
  </ng-container>
  <ng-container matColumnDef="uploadReport">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Upload Report</th>
    <td mat-cell *matCellDef="let element">
      <button *ngIf="element.report" mat-raised-button color="accent" (click)="showUploadReport(element.report)">Show</button>
    </td>
  </ng-container>
  <tr
    class="no-padding"
    mat-header-row
    *matHeaderRowDef="displayedColumns"
  ></tr>
  <tr
    class="no-padding"
    mat-row
    *matRowDef="let row; columns: displayedColumns"
  ></tr>
</table>
